import { Box, Container, Typography } from '@mui/material';
import { brandGradient } from '../shared-theme/themePrimitives';

export default function StaticPage({ title, subtitle, children, maxWidth = 'md' }) {
    return (
        <Container maxWidth={maxWidth} sx={{ py: { xs: 4, sm: 6 } }}>
            <Box sx={{ textAlign: 'center', mb: 5 }}>
                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: 700,
                        fontSize: { xs: '2rem', sm: '2.5rem' },
                        background: brandGradient,
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        display: 'inline-block',
                    }}
                >
                    {title}
                </Typography>
                {subtitle && (
                    <Typography color="text.secondary" sx={{ mt: 1 }}>
                        {subtitle}
                    </Typography>
                )}
            </Box>
            {children}
        </Container>
    );
}
